import { setUpOnboardingConfig } from 'growth-onboarding-signup-redirect/redirect';
import { getIntentLink } from '../intents/intentSelectors';
import { getHublet, getIsNewUser } from '../store/app/selectors';
import { getAuth, getPortalId } from '../store/auth/selectors';
import { getSurveyDataForRedirect } from '../store/signup-data/selectors';
import { getOnboardingUrl } from './getOnboardingUrl';
import { getRedirectSignupType } from './getRedirectSignupType';
import { getSpecificEnrollment, getSpecificRedirect } from './getFlowSpecificRedirect';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import getOnboardingRedirectOptions from './getOnboardRedirectOptions';
import { getActiveExperiments } from '../experiments/ExperimentUtils';
import { getCurrentStepNumbering } from '../flow-management/stepNumberingSelectors';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { getShouldShowSidePanel } from '../utils/getShouldShowSidePanel';
import { isEligibleForACQ177ProductisedFlow } from '../utils/gtkm/isEligibleForACQ177ProductisedFlow';
import { getIsExistingUserSession } from '../store/app/selectors';
import { isPurchaseProductisedFlow } from '../utils/gtkm/isPurchaseProductisedFlow';
import { isMarketingProductisedFlow } from '../utils/gtkm/isMarketingProductisedFlow';
import { isExistingUser } from '../app/verificationTypeSelectors';
const LOG = Logger.getLogger('getRedirectMethod');
export const getRedirectMethod = state => {
  const portalId = getPortalId(state);
  const auth = getAuth(state);
  const hublet = getHublet(state);
  const survey = getSurveyDataForRedirect(state);
  const intentLink = getIntentLink(state);
  const signupType = getRedirectSignupType();
  const specificRedirect = getSpecificRedirect();
  const specificEnrollment = getSpecificEnrollment();
  const flowKey = getFlowKey();
  const integrationKey = getIntegrationKey();
  const activeExperiments = getActiveExperiments(state);
  const {
    currentStep: signupStepNumber,
    totalSteps: signupTotalSteps
  } = getCurrentStepNumbering(state);
  const isAssignedToACQ177Variant = isEligibleForACQ177ProductisedFlow(state) || getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0177, [ExperimentParameterGroup.Variant_A]);
  const isAssignedToGTKM = isAssignedToACQ177Variant;
  const isNewUser = isAssignedToACQ177Variant && (isPurchaseProductisedFlow() && isExistingUser(state) || isMarketingProductisedFlow() && getIsExistingUserSession(state)) ? true : getIsNewUser(state);
  const isSidepanelLayout = getShouldShowSidePanel() || isAssignedToGTKM;
  const progressBadge = isSidepanelLayout ? true : undefined;
  const totalSteps = isSidepanelLayout ? signupTotalSteps : undefined;
  return specificRedirect ? () => {
    const maybeSpecificOnboardingConfigSetup = specificEnrollment ? setUpOnboardingConfig(getOnboardingRedirectOptions(portalId, specificEnrollment, hublet, auth, signupStepNumber, totalSteps, progressBadge, survey)) : Promise.resolve();
    return maybeSpecificOnboardingConfigSetup.then(() => specificRedirect(state)).catch(error => {
      LOG.error(`Failed to build specific redirect for flow: ${flowKey} ${integrationKey}`, {
        extra: getSentryExtra(error)
      });
      return Promise.reject(error);
    });
  } : () => {
    return getOnboardingUrl({
      portalId,
      auth,
      survey,
      intentLink,
      hublet,
      signupExperimentTreatments: activeExperiments
    }, signupType, isNewUser, signupStepNumber, totalSteps, progressBadge);
  };
};